// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import {api} from '../Login/axiosConfig';
// import { useAuth } from '../../AuthContext';
// import { AppBar, Toolbar, TextField, Button, Grid, Typography, Container, MenuItem, Select, InputLabel, FormControl, Box, Snackbar, Alert, FormHelperText, RadioGroup, FormControlLabel, Radio, Link as MuiLink } from '@mui/material';
// import { useParams } from 'react-router-dom';
// import GenerateMeetingLinkButton from '../GoogleMeet/GenerateMeetingLinkButton';
// import { format } from 'date-fns';
// import GenerateZoomMeetingButton from '../Zoom/GenerateZoomMeetingButton';
// import ZoomAuthButton from '../Zoom/ZoomAuthButton';
// import GenerateMicrosoftTeamsLink from '../Microsoft/GenerateMicrosoftTeamsLink';
// import GoogleMeetLogo from '../Post/GoogleMeetImage.png';
// import ZoomMeetLogo from '../Post/ZoomMeetImage.png';
// import TeamsMeetLogo from '../Post/TeamsMeetImage.png';
// import { parseISO } from 'date-fns';
// import Header1 from '../Header/Header1';
// import Platform from '../Platform/Platform';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import { Link } from 'react-router-dom';
// import Footer2 from '../Footer/Footer2';
// import { Stack } from '@mui/material';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import CircularProgress from '@mui/material/CircularProgress';

// const API_URL = process.env.REACT_APP_API_URL;

// const styles = {
//   glassBox: {
//     backdropFilter: 'blur(15px)',
//     backgroundColor: '#000000',
//     borderRadius: '16px',
//     padding: '2.5rem',
//     boxShadow: '0 4px 30px rgba(0, 0, 0, 0.2)',
//     border: '1px solid rgba(255, 255, 255, 0.3)',
//     width: '100%',
//     maxWidth: '100%',
//     textAlign: 'center',
//   },
//   logo: {
//     width: '160px',
//     height: '160px',
//     margin: '0 auto 1rem',
//   },
//   text: {
//     color: 'white',
//   },
//   root: {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100vh',
//     backgroundColor: 'rgba(0, 0, 0, 0.8)',
//     width: '100%',
//   },
//   input: {
//     marginBottom: '1rem',
//     letterSpacing: 2,
//     '& .MuiInputBase-input': {
//       color: 'white',
//     },
//     '& .MuiInputLabel-root': {
//       color: 'rgba(255, 255, 255, 0.7)',
//       transition: 'color 0.3s',
//     },
//     '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
//       borderColor: 'rgba(255, 255, 255, 0.5)',
//     },
//     '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
//       borderColor: '#1E90FF',
//     },
//     '&:hover .MuiInputLabel-root': {
//       color: '#1E90FF',
//     },
//     '& .MuiSelect-root:hover .MuiOutlinedInput-notchedOutline': {
//       borderColor: '#1E90FF',
//     },
//   },
//   dateInput: {
//     marginBottom: '1rem',
//     '& .MuiInputBase-input': {
//       color: 'white',
//     },
//     '& .MuiInputBase-input::placeholder': {
//       color: 'transparent',
//       transition: 'color 0.3s',
//     },
//     '& .MuiInputLabel-root': {
//       color: 'rgba(255, 255, 255, 0.7)',
//       transition: 'color 0.3s',
//     },
//     '& .Mui-focused .MuiInputBase-input::placeholder': {
//       color: 'white',
//     },
//     '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
//       borderColor: 'rgba(255, 255, 255, 0.5)',
//     },
//     '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
//       borderColor: '#1E90FF',
//     },
//     '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
//       borderColor: '#1E90FF',
//     },
//   },
//   button: {
//     backgroundColor: '#1E90FF',
//     color: 'white',
//     marginTop: '1.5rem',
//   },

// };

// const CreateRequest1 = ({ onLogout }) => {

//   useEffect(() => {
//     window.scrollTo(0, 0);  // Scroll to top when this page is loaded
//   }, []);

//   const { userId } = useAuth();
//   const { role } = useAuth();
//   const [startTime, setStartTime] = useState('');
//   const [duration, setDuration] = useState('');
//   const [selectedDate, setSelectedDate] = useState('');
//   const [maxLimit, setMaxLimit] = useState('');
//   const [price, setPrice] = useState(0);
//   const [topicName, setTopicName] = useState('');
//   const [description, setDescription] = useState('');
//   const [sectionId, setSectionId] = useState('');
//   const [subsectionId, setSubsectionId] = useState('');
//   const [sections, setSections] = useState([]);
//   const [subsections, setSubsections] = useState([]);
//   const [error, setError] = useState('');
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   // const [language, setLanguage] = useState('');
//   const [language, setLanguage] = useState([]);
//   const [meetingLink, setMeetingLink] = useState("");
//   const [googleMeetLink, setGoogleMeetLink] = useState('');
//   const defaultLanguages = [
//     { id: 'assamese', name: 'Assamese' },
//     { id: 'bengali', name: 'Bengali' },
//     { id: 'bodo', name: 'Bodo' },
//     { id: 'dogri', name: 'Dogri' },
//     { id: 'gujarati', name: 'Gujarati' },
//     { id: 'hindi', name: 'Hindi' },
//     { id: 'kannada', name: 'Kannada' },
//     { id: 'kashmiri', name: 'Kashmiri' },
//     { id: 'konkani', name: 'Konkani' },
//     { id: 'maithili', name: 'Maithili' },
//     { id: 'malayalam', name: 'Malayalam' },
//     { id: 'manipuri', name: 'Manipuri' },
//     { id: 'marathi', name: 'Marathi' },
//     { id: 'nepali', name: 'Nepali' },
//     { id: 'odia', name: 'Odia' },
//     { id: 'punjabi', name: 'Punjabi' },
//     { id: 'sanskrit', name: 'Sanskrit' },
//     { id: 'santali', name: 'Santali' },
//     { id: 'sindhi', name: 'Sindhi' },
//     { id: 'telugu', name: 'Telugu' },
//     { id: 'tamil', name: 'Tamil' },
//     { id: 'urdu', name: 'Urdu' },
//     { id: 'english', name: 'English' },
//   ];
//   const [languages, setLanguages] = useState(defaultLanguages);  // State for languages
//   const [platform, setPlatform] = useState("");
//   const [isValid, setIsValid] = useState(null);
//   const [status, setStatus] = useState(null);
//   const [id, setId] = useState(null);
//   const [title, setTitle] = useState('');
//   const location = useLocation();
//   const [ppt, setPpt] = useState(null);


//   // to track the validity of the link
//   const [errorMessage, setErrorMessage] = useState("");

//   const navigate = useNavigate();
//   const [goPriceless, setGoPriceless] = useState(false);


//   const [isVerified, setIsVerified] = useState(false);
//   const [loading, setLoading] = useState(false); // to track check status
//   const [loadingSeconds, setLoadingSeconds] = useState(0);

//   const [userData, setUserData] = useState({
//     name: '',
//     surname: '',
//     image: '',
//     role: '',
//   });

//   const [media, setMedia] = useState(null);
//   const [mediaPreview, setMediaPreview] = useState(null);


//   useEffect(() => {
//     let timer;

//     if (loading) {
//       setLoadingSeconds(0); // reset timer
//       timer = setInterval(() => {
//         setLoadingSeconds(prev => prev + 1);
//       }, 1000);
//     } else {
//       clearInterval(timer);
//       setLoadingSeconds(0); // optional reset after done
//     }

//     return () => clearInterval(timer); // cleanup on unmount or loading = false
//   }, [loading]);


//   useEffect(() => {
//     if (role === 'expert' || role === 'admin') {
//       setIsVerified(true);
//     }
//   }, [role]);




//   useEffect(() => {
//     api.get(`${API_URL}/list_sections_and_subsections/?user_id=${userId}`)
//       .then((response) => {
//         const transformedSections = Object.entries(response.data.sections).map(([sectionName, sectionData]) => ({
//           sectionId: sectionData.section_id,
//           sectionName,
//           subsections: sectionData.subsections,
//         }));
//         setSections(transformedSections);


//         const apiLanguages = response.data.languages;
//  if (Array.isArray(apiLanguages) && apiLanguages.length > 0) {
//   const transformedLanguages = apiLanguages.map((lang, index) => {
//     if (typeof lang === 'string') {
//       return {
//         id: lang.toLowerCase().replace(/\s+/g, '_'),
//         name: lang,
//       };
//     }
//     return {
//       id: lang?.id || `${index}`,
//       name: lang?.name || lang?.label || lang?.value || '',
//     };
//   }).filter((lang) => lang.name);

//   setLanguages(transformedLanguages);
// } else {
//   setLanguages([]); // ❗ no default fallback
// }
//       })
//       .catch((error) => {
//         console.error('Error fetching sections:', error);
//       });
//   }, [userId]);

//   useEffect(() => {
//     if (!userId) {
//       return;
//     }

//     // Fetch user data
//     api.get(`${API_URL}/get_user_data/?user_id=${userId}`)
//       .then((response) => {
//         setUserData(response.data);
//       })
//       .catch((err) => console.error(err));
//   }, [userId]);


//   const showAlert = () => {
//     const alertDiv = document.createElement('div');

//     alertDiv.textContent = isVerified
//       ? 'Session created successfully.'
//       : 'Request session created successfully.';
//     alertDiv.style.position = 'fixed';
//     alertDiv.style.top = '100px';
//     alertDiv.style.left = '50%';
//     alertDiv.style.transform = 'translateX(-50%)';
//     alertDiv.style.padding = '50px 100px';
//     alertDiv.style.backgroundColor = '#1E90FF';
//     alertDiv.style.color = 'black';
//     alertDiv.style.borderRadius = '5px';
//     alertDiv.style.zIndex = '9999';
//     alertDiv.style.fontSize = '16px';

//     document.body.appendChild(alertDiv);

//     setTimeout(() => {
//       alertDiv.remove();
//     }, 20000);
//   };

//   const handleDateChange = (event) => {
//     setSelectedDate(event.target.value);
//   };

//   const getMediaTypeFromFile = (file) => {
//     const ext = file.name.split('.').pop().toLowerCase();
//     const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
//     const videoExts = ['mp4', 'mov', 'avi', 'mkv'];

//     if (imageExts.includes(ext)) return 'image';
//     if (videoExts.includes(ext)) return 'video';
//     return 'unknown';
//   };



//   const handleUploadToCloudinary = async (file) => {
//     const cloudName = 'dywuk1huu'; // Replace with your actual Cloudinary cloud name
//     const uploadPreset = 'anthra_cloud_01'; // Replace with your Cloudinary unsigned upload preset

//     const formData = new FormData();
//     formData.append('file', file);
//     formData.append('upload_preset', uploadPreset);

//     try {
//       const response = await api.post(
//         `https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`,
//         formData
//       );

//       return response.data.secure_url;
//     } catch (error) {
//       console.error('Cloudinary upload failed:', error);
//       throw error;
//     }
//   };

//   const MAX_FILE_SIZE = 100 * 1024 * 1024; // 5 MB

// const ALLOWED_TYPES = [
//   "image/jpeg",
//   "image/png",
//   "image/webp",
//   "image/gif",
//   "video/mp4",
//   "video/webm",
//   "video/quicktime", // .mov
// ];

// const validateFile = (file) => {
//   if (!file) return "No file selected";

//   if (!ALLOWED_TYPES.includes(file.type)) {
//     return "Only images and videos are allowed";
//   }

//   if (file.size > MAX_FILE_SIZE) {
//     return "File size must be less than 5 MB";
//   }

//   return null;
// };



//   const getPresignedUrl = async (file) => {
//   const res = await api.post(`${API_URL}/api/presigned-url/`, {
//     file_name: file.name,
//     file_type: file.type,
//     file_size: file.size,
//   });

//   return res.data;
// };


// const uploadToS3 = async (file) => {
//   const error = validateFile(file);
//   if (error) {
//     alert(error); // or MUI Snackbar
//     return null;
//   }

//   const { upload_url, key } = await getPresignedUrl(file);

//   await axios.put(upload_url, file, {
//     headers: {
//       "Content-Type": file.type,
//     },
//   });

//   return key;
// };




//   // const uploadToS3 = async (file) => {
//   //     if (!file) return null;
  
//   //     const formData = new FormData();
//   //     formData.append("file", file);
  
//   //     const uploadRes = await api.post(`${API_URL}/api/upload-s3/`, formData, {
//   //       headers: { "Content-Type": "multipart/form-data" },
//   //     });
//   //     return uploadRes.data.key;
//   //   };

//   // const cloudName = 'dywuk1huu';
//   //   const uploadPreset = 'anthra_cloud_01';

//   const handlePost = async () => {

//     const requiredFields = [
//       { field: description, fieldName: "Description" },
//       { field: language, fieldName: "Language" },
//       { field: duration, fieldName: "Duration" },
//       // { field: price, fieldName: "Price" },
//       { field: selectedDate, fieldName: "Select date" },
//       { field: startTime, fieldName: "Start Time" },
//     ];


//     for (let { field, fieldName } of requiredFields) {
//       if (fieldName === 'Price') {
//         if (!goPriceless && (field === undefined || field === null || field.toString().trim() === '' || Number(field) === 0)) {
//           setError('Price is required unless you choose Go Priceless.');
//           setOpenSnackbar(true);
//           return;
//         }
//         continue;
//       }

//       if (field === undefined || field === null || field.toString().trim() === "") {
//         setError(`${fieldName} is required.`);
//         setOpenSnackbar(true);
//         return;
//       }
//     }


//     // Validate startTime format (HH:mm) before passing to postData
//     if (startTime && !/^\d{2}:\d{2}$/.test(startTime)) {
//       setError('Start Time must be in the format HH:mm.');
//       setOpenSnackbar(true);
//       return;
//     }


//     if (startTime) {
//       const today = new Date();
//       const timeParts = startTime.split(':');
//       today.setHours(timeParts[0], timeParts[1]);

//       const formattedStartTime = format(today, "yyyy-MM-dd'T'HH:mm:ss");

//       const parsedStartTime = parseISO(formattedStartTime);

//       if (isNaN(parsedStartTime)) {
//         setError('Invalid start time.');
//         setOpenSnackbar(true);
//         return;
//       }
//     }



//     // Validate the duration
//     if (duration > 300) {
//       setError('Duration cannot exceed 300 minutes.');
//       setOpenSnackbar(true);
//       return;
//     }

    

    
//     setLoading(true);

//     let mediaKey = null;
//     let mediaType = null;

//     if (media) {
//       try {
//         mediaType = getMediaTypeFromFile(media); // detect manually
//         mediaKey = await uploadToS3(media);
//         // mediaUrl = await handleUploadToCloudinary(media); // upload to cloudinary
//       } catch (err) {
//         setError("Failed to upload media.");
//         setOpenSnackbar(true);
//         setLoading(false);
//         return;
//       }
//     }


//     const selectedSection = sections.find(section => section.sectionId === sectionId);
//     const sectionName = selectedSection ? selectedSection.sectionName : '';

//     const selectedSubsection = subsections.find(subsection => subsection.id === subsectionId);
//     const subsectionName = selectedSubsection ? selectedSubsection.name : '';

//     const formData = new FormData();

//     const selectedDateTime = `${selectedDate}T${startTime}`;

//     const data = {
//       user_id: userId,
//       section_id: sectionId,
//       section_name: sectionName,
//       subsection_id: subsectionId,
//       subsection_name: subsectionName,
//       startTime: startTime,
//       duration: duration,
//       selectedDate: selectedDate,
//       selected_date_and_time: selectedDateTime,
//       max_limit: maxLimit,
//       price: price,
//       title: topicName,
//       description: description,
//       language: language,
//       media_key: mediaKey || null,
//       media_type: mediaType || null,
//     };

  


//     const endpoint = isVerified ? 'create_post' : 'create_request';
//     const subscriptionError = isVerified
//       ? 'You need an active subscription to post.'
//       : 'You need an active subscription to request.';
//     const generalError = isVerified
//       ? 'An error occurred while posting. Please try again later.'
//       : 'An error occurred while creating request. Please try again later.';

//     setLoading(true);

//     api.post(`${API_URL}/${endpoint}/`, data, {
//       // headers: {
//       //   'Content-Type': 'multipart/form-data',
//       // },
//       headers: { "Content-Type": "application/json" },
//       withCredentials: true,
//     })
//       .then((response) => {
//         setStatus('success');
//         setId(response.data.id);
//       })
//       .catch((error) => {
//         // console.error('Error sending data:', error);
//         console.error("Error sending data:", error);

//   if (error.response) {
//     console.log("SERVER ERROR DATA:", error.response.data);  // ADD THIS
//   }
//         if (error.response && error.response.status === 403) {
//           setError(subscriptionError);
//         } else {
//           setError(generalError);
//         }
//         setOpenSnackbar(true);
//       })
//       .finally(() => {
//         setLoading(false); // stop loader
//       });
//   };


//   const handleChange = (event) => {
//     setLanguage(event.target.value);
//   };

//   const handleRedirect = () => {
//     navigate('/requesting-guidelines');  // Redirect to meeting guidelines page
//   };


//   const handleDurationChange = (e) => {
//     setDuration(e.target.value);
//   };

//   const durationOptions = [];
//   for (let i = 30; i <= 300; i += 30) {
//     durationOptions.push(i);
//   }

//   const handleMaxLimitChange = (e) => {
//     setMaxLimit(e.target.value);
//   };

//   const maxLimitOptions = [];
//   for (let i = 10; i <= 100; i += 10) {
//     maxLimitOptions.push(i);
//   }

//   const handlePriceChange = (e) => {
//     setPrice(e.target.value);
//   };

//   // Generate price options based on intervals
//   const priceOptions = [];

//   // Interval of 10 from 0 to 100
//   for (let i = 10; i <= 100; i += 10) {
//     priceOptions.push(i);
//   }

//   // Interval of 25 from 100 to 300
//   for (let i = 125; i <= 300; i += 25) {
//     priceOptions.push(i);
//   }

//   // Interval of 50 from 300 to 500
//   for (let i = 350; i <= 500; i += 50) {
//     priceOptions.push(i);
//   }

//   const handleRadioChange = (event) => {
//     const isGoPriceless = event.target.value === "goPriceless";
//     setGoPriceless(isGoPriceless);
//     if (isGoPriceless) {
//       setPrice(0); // Set price to 0 if "Go priceless" is selected
//     } else {
//       setPrice(''); // Reset the price selection when going back to "Set Price"
//     }
//   };

//   // const handleFileChange = (event) => {
//   //   const file = event.target.files[0];
//   //   if (!file) return;

//   //   setMedia(file);
//   //   setMediaPreview(URL.createObjectURL(file));
//   // };


//   // const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

// const handleFileChange = (event) => {
//   const file = event.target.files[0];
//   if (!file) return;

//   if (file.size > MAX_FILE_SIZE) {
//     alert("File size must be less than 5 MB");
//     event.target.value = ""; // reset input
//     return;
//   }

//   setMedia(file);
//   setMediaPreview(URL.createObjectURL(file));
// };


//   const [step, setStep] = useState(0);
//   const totalSteps = 3;

//   const validateStep = () => {
//     if (step === 0) {
//       if (!topicName.trim()) {
//         setError('Session title is required.');
//         setOpenSnackbar(true);
//         return false;
//       }
//       if (!description.trim()) {
//         setError('Description is required.');
//         setOpenSnackbar(true);
//         return false;
//       }
//     }

//     if (step === 1) {
//       if (!language) {
//         setError('Please select a language.');
//         setOpenSnackbar(true);
//         return false;
//       }
//     }

//     if (step === 2) {
//       if (!selectedDate) {
//         setError('Please select a date.');
//         setOpenSnackbar(true);
//         return false;
//       }
//       if (!startTime) {
//         setError('Please select a start time.');
//         setOpenSnackbar(true);
//         return false;
//       }
//       if (!duration) {
//         setError('Please select a duration.');
//         setOpenSnackbar(true);
//         return false;
//       }
//     }

//     if (step === 3) {
//       if (!goPriceless && (!price || Number(price) <= 0)) {
//         setError('Please select a price or choose Go Priceless.');
//         setOpenSnackbar(true);
//         return false;
//       }
//     }

//     return true;
//   };

//   const handleNext = () => {
//     if (step < totalSteps - 1 && validateStep()) {
//       setStep((prev) => prev + 1);
//     }
//   };

//   const handleBack = () => {
//     if (step > 0) setStep((prev) => prev - 1);
//   };

//   const isActive = (path) => location.pathname === path;


//   return (
//     <div style={{ backgroundColor: '#000000', minHeight: '100vh', color: '#ffffff', }}>
//       <Box
//         sx={{
//           position: 'fixed', // or 'relative' / 'sticky' based on your layout
//           top: 0,
//           left: 0,
//           width: '100%',
//           zIndex: 1300, // higher than MUI drawers (default is 1200)
//         }}
//       >
//         <Header1 onLogout={onLogout} />
//       </Box>


//       <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//         <Box>
//           <Platform userId={userId} onLogout={onLogout} />
//         </Box>

//         <Box position="static" color="primary" sx={{ mt: 5, backgroundColor: '#000000' }}>
//           <Toolbar>
//             <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', gap: 2 }}>

//               {/* Single Button */}
//               <Button
//                 variant={isActive('/platform/create') ? 'contained' : 'outlined'}
//                 color={isActive('/platform/create') ? 'secondary' : 'inherit'}
//                 onClick={() => navigate('/platform/create')}
//                 sx={{
//                   borderRadius: '20px',
//                   textTransform: 'none',
//                   fontWeight: 'bold',
//                   px: 3,
//                   py: 1,
//                   bgcolor: isActive('/platform/create') ? 'secondary.main' : 'transparent',
//                   color: isActive('/platform/create') ? 'white' : 'inherit',
//                   border: '2px solid',
//                   borderColor: isActive('/platform/create') ? 'primary.main' : 'inherit',
//                   '&:hover': {
//                     bgcolor: isActive('/platform/create') ? 'secondary.dark' : 'action.hover',
//                     borderColor: 'primary.main',
//                   },
//                 }}
//               >
//                 Single
//               </Button>

//               {/* Multiple Button */}
//               <Button
//                 variant={isActive('/platform/create-series') ? 'contained' : 'outlined'}
//                 color={isActive('/platform/create-series') ? 'secondary' : 'inherit'}
//                 onClick={() => navigate('/platform/create-series')}
//                 sx={{
//                   borderRadius: '20px',
//                   textTransform: 'none',
//                   fontWeight: 'bold',
//                   px: 3,
//                   py: 1,
//                   bgcolor: isActive('/platform/create-series') ? 'secondary.main' : 'transparent',
//                   color: isActive('/platform/create-series') ? 'white' : 'inherit',
//                   border: '2px solid',
//                   borderColor: isActive('/platform/create-series') ? 'primary.main' : 'inherit',
//                   '&:hover': {
//                     bgcolor: isActive('/platform/create-series') ? 'secondary.dark' : 'action.hover',
//                     borderColor: 'primary.main',
//                   },
//                 }}
//               >
//                 Multiple
//               </Button>

//             </Box>
//           </Toolbar>
//         </Box>



//         <Box>
//           <Container maxWidth="lg" sx={{
//             marginBottom: { xs: '2rem', sm: '3rem', lg: '5rem' }, padding: '0 2rem',
//             // mt: {
//             //   xs: 10,   // Mobile
//             //   sm: 15,   // Small screens
//             //   md: 20,   // Medium screens
//             //   lg: 25,   // Large screens
//             //   xl: 30,   // Extra-large screens
//             // }
//           }}>
//             <Box sx={{
//               padding: '2rem',
//               borderRadius: '8px',
//               backgroundColor: '#000000',
//               transition: 'border-color 0.3s ease',
//               '&:hover': { borderColor: '#1E90FF' },
//             }}>
//               <Typography variant="h4" component="h1" sx={{
//                 marginTop: '1.5rem',
//                 textAlign: 'center',
//                 letterSpacing: 5,
//                 mb: 2,
//                 color: 'transparent',
//                 backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//               }}>
//                 Hi {userData.name},
//               </Typography>

//               {step === 0 && (

//                 <>


//                   <Typography
//                     variant="h6"
//                     sx={{
//                       textAlign: 'center',
//                       letterSpacing: 2,
//                       mb: { xs: 6, sm: 8, md: 10 },
//                       color: 'transparent',
//                       backgroundImage: 'linear-gradient(45deg, white, white)',
//                       backgroundClip: 'text',
//                       WebkitBackgroundClip: 'text',
//                       fontStyle: 'italic',
//                       fontWeight: 500,
//                       fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' },
//                       px: 2,
//                     }}
//                   >
//                     Tell us what would you like to{' '}
//                     {isVerified
//                       ? 'share in a real-time knowledge session.'
//                       : 'learn. We will connect you with an expert for a real-time knowledge session.'}
//                   </Typography>

//                   <Box
//                     sx={{
//                       width: { xs: '100%', sm: '95%', md: '90%', lg: '80%', xl: '70%' },
//                       mx: 'auto',
//                       px: { xs: 2, sm: 3, md: 4 },
//                     }}
//                   >
//                     {/* Session Title or Topic */}
//                     <TextField
//                       label={isVerified ? 'Session Title' : 'Ask us anything...'}
//                       variant="outlined"
//                       fullWidth
//                       multiline
//                       rows={2}
//                       value={topicName}
//                       onChange={(e) =>
//                         e.target.value.length <= 100 && setTopicName(e.target.value)
//                       }
//                       helperText={`${topicName.length}/100 characters`}
//                       inputProps={{
//                         maxLength: 100,
//                         style: { letterSpacing: 1.5, paddingTop: 18 },
//                       }}
//                       InputLabelProps={{
//                         shrink: true,
//                         sx: {
//                           letterSpacing: 1.5,
//                           backgroundColor: 'background.default',
//                           px: 0.5,
//                           transform: 'translate(14px, -9px) scale(0.75)',
//                         },
//                       }}
//                       FormHelperTextProps={{
//                         sx: {
//                           letterSpacing: 1.5,
//                           color: topicName.length > 100 ? 'warning.main' : 'text.secondary',
//                         },
//                       }}
//                       sx={{
//                         mb: 3,
//                         '& .MuiOutlinedInput-root': {
//                           borderRadius: 3,
//                           backgroundColor: 'background.paper',
//                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
//                           '&:hover fieldset': { borderColor: 'primary.main' },
//                           '&.Mui-focused fieldset': { borderColor: 'primary.dark', borderWidth: 1.5 },
//                         },
//                       }}
//                     />

//                     {/* Description */}
//                     <TextField
//                       label={isVerified ? 'Brief Description' : 'Ask us anything...'}
//                       variant="outlined"
//                       fullWidth
//                       multiline
//                       rows={4}
//                       value={description}
//                       onChange={(e) =>
//                         e.target.value.length <= 500 && setDescription(e.target.value)
//                       }
//                       helperText={`${description.length}/500 characters`}
//                       inputProps={{
//                         maxLength: 500,
//                         style: { letterSpacing: 1.5, paddingTop: 18 },
//                       }}
//                       InputLabelProps={{
//                         shrink: true,
//                         sx: {
//                           letterSpacing: 1.5,
//                           backgroundColor: 'background.default',
//                           px: 0.5,
//                           transform: 'translate(14px, -9px) scale(0.75)',
//                         },
//                       }}
//                       FormHelperTextProps={{
//                         sx: {
//                           letterSpacing: 1.5,
//                           color: description.length > 450 ? 'warning.main' : 'text.secondary',
//                         },
//                       }}
//                       sx={{
//                         mb: 4,
//                         '& .MuiOutlinedInput-root': {
//                           borderRadius: 3,
//                           backgroundColor: 'background.paper',
//                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
//                           '&:hover fieldset': { borderColor: 'primary.main' },
//                           '&.Mui-focused fieldset': { borderColor: 'primary.dark', borderWidth: 1.5 },
//                         },
//                       }}
//                     />

//                     {/* Media Preview ABOVE upload button */}
//                     {mediaPreview && (
//                       <Box
//                         sx={{
//                           mb: 3,
//                           borderRadius: 3,
//                           overflow: 'hidden',
//                           boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                           maxHeight: 1000,
//                           maxWidth: '100%',
//                           mx: 'auto',
//                         }}
//                       >
//                         {media?.type.startsWith('image/') ? (
//                           <img
//                             src={mediaPreview}
//                             alt="Preview"
//                             style={{ width: '100%', objectFit: 'contain', display: 'block' }}
//                           />
//                         ) : (
//                           <video
//                             controls
//                             src={mediaPreview}
//                             style={{ width: '100%', display: 'block' }}
//                           />
//                         )}
//                       </Box>
//                     )}

//                     <Button
//   component="label"
//   variant="contained"
//   startIcon={<CloudUploadIcon />}
//   sx={{
//     mb: 3,
//     px: 4,
//     py: 1.5,
//     borderRadius: 3,
//     textTransform: 'none',
//     fontWeight: 600,
//     fontSize: '1rem',
//     backgroundColor: 'primary.main',
//     '&:hover': {
//       backgroundColor: 'primary.dark',
//     },
//     boxShadow: '0 2px 8px rgba(25, 118, 210, 0.4)',
//   }}
// >
//   <Stack direction="column" alignItems="flex-start" spacing={0.3}>
//     <Typography variant="body1" sx={{ fontWeight: 600, color: 'whitesmoke' }}>
//       Upload Media 
//     </Typography>
//     <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.8)' }}>
//       Max file size: 5 MB (Image/Video accepted)
//     </Typography>
//   </Stack>

//   <input
//     type="file"
//     accept="image/*,video/*"
//     hidden
//     onChange={handleFileChange}
//   />
// </Button>


//                     {/* File Upload Button */}
//                     {/* <Button
//                       component="label"
//                       variant="contained"
//                       startIcon={<CloudUploadIcon />}
//                       sx={{
//                         mb: 3,
//                         px: 4,
//                         py: 1.5,
//                         borderRadius: 3,
//                         textTransform: 'none',
//                         fontWeight: 600,
//                         fontSize: '1rem',
//                         backgroundColor: 'primary.main',
//                         '&:hover': {
//                           backgroundColor: 'primary.dark',
//                         },
//                         boxShadow: '0 2px 8px rgba(25, 118, 210, 0.4)',
//                       }}
//                     >
//                       <Stack direction="column" alignItems="flex-start" spacing={0.3}>
//                         <Typography variant="body1" sx={{ fontWeight: 600, color: 'whitesmoke' }}>
//                           Upload Media
//                         </Typography>
                        
//                       </Stack>
//                       <input
//                         type="file"
//                         accept="image/*,video/*"
//                         hidden
//                         onChange={handleFileChange}
//                       />
//                     </Button> */}
//                   </Box>

//                   <Typography
//                     variant="body1"
//                     sx={{
//                       textAlign: 'center',
//                       mb: 4,
//                       letterSpacing: 2,
//                       color: 'white',
//                       fontWeight: 500,
//                       fontSize: {
//                         xs: '0.95rem',
//                         sm: '1.05rem',
//                       },
//                     }}
//                   >
//                     Step {step + 1} of {totalSteps}
//                   </Typography>



//                 </>

//               )}




//               {step === 1 && (
//                 <>
//                   <Box
//                     sx={{
//                       width: {
//                         xs: '100%',
//                         sm: '100%',
//                         md: '80%',
//                         lg: '70%',
//                         xl: '60%',
//                       },
//                       mx: 'auto',
//                       px: {
//                         xs: 2,
//                         sm: 3,
//                         md: 4,
//                       },
//                     }}
//                   >
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         textAlign: 'center',
//                         letterSpacing: 2,
//                         mb: 5,
//                         color: 'transparent',
//                         backgroundImage: 'linear-gradient(45deg, white, white)',
//                         backgroundClip: 'text',
//                         WebkitBackgroundClip: 'text',
//                         fontStyle: 'italic',
//                         fontSize: {
//                           xs: '1rem',
//                           sm: '1.2rem',
//                           md: '1.4rem',
//                         },
//                       }}
//                     >
//                       Please select the language in which you will be communicating during the session.
//                     </Typography>

//                     <Box
//                       sx={{
//                         display: 'flex',
//                         flexWrap: 'wrap',
//                         gap: 2,
//                         justifyContent: 'center',
//                         mb: 4,
//                       }}
//                     >
//                       {languages.length > 0 ? (
//                         languages.map((lang) => (
//                           <Button
//                             key={lang.id}
//                             variant={language === lang.name ? 'contained' : 'outlined'}
//                             onClick={() => handleChange({ target: { value: lang.name } })}
//                             sx={{
//                               letterSpacing: 2,
//                               color: 'white',
//                               borderColor: '#555',
//                               backgroundColor:
//                                 language === lang.name ? '#1E90FF' : 'transparent',
//                               '&:hover': {
//                                 backgroundColor: '#1E90FF',
//                                 borderColor: '#1E90FF',
//                               },
//                             }}
//                           >
//                             {lang.name}
//                           </Button>
//                         ))
//                       ) : (
//                         <Typography
//                           variant="body2"
//                           sx={{ color: '#ccc', textAlign: 'center', width: '100%' }}
//                         >
//                           No language options are available right now. Please try again later.
//                         </Typography>
//                       )}
//                     </Box>
//                   </Box>

//                   <Typography
//                     variant="body1"
//                     sx={{
//                       textAlign: 'center',
//                       mb: 4,
//                       mt: 4,
//                       letterSpacing: 2,
//                       color: 'white',
//                       fontWeight: 500,
//                       fontSize: {
//                         xs: '0.95rem',
//                         sm: '1.05rem',
//                       },
//                     }}
//                   >
//                     Step {step + 1} of {totalSteps}
//                   </Typography>


//                 </>
//               )}


//               {step === 2 && (
//                 <>
//                   <Box
//                     sx={{
//                       width: {
//                         xs: '100%',
//                         sm: '100%',
//                         md: '80%',
//                         lg: '70%',
//                         xl: '60%',
//                       },
//                       mx: 'auto',
//                       px: { xs: 2, sm: 3, md: 4 },
//                     }}
//                   >
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         textAlign: 'center',
//                         letterSpacing: 2,
//                         mb: { xs: 5, sm: 6, md: 8 },
//                         color: 'transparent',
//                         backgroundImage: 'linear-gradient(45deg, white, white)',
//                         backgroundClip: 'text',
//                         WebkitBackgroundClip: 'text',
//                         fontStyle: 'italic',
//                         fontWeight: 600,
//                         fontSize: { xs: '1rem', sm: '1.2rem', md: '1.4rem' },
//                         userSelect: 'none',
//                       }}
//                     >
//                       Please select an available date, time and duration for the session.
//                     </Typography>

//                     <Box
//                       sx={{
//                         display: { xs: 'block', md: 'flex' },
//                         gap: { xs: 3, md: 4 },
//                         alignItems: 'center',
//                       }}
//                     >
//                       {/* Date Picker */}
//                       <TextField
//                         label="Select Date"
//                         type="date"
//                         fullWidth
//                         value={selectedDate}
//                         onChange={handleDateChange}
//                         InputLabelProps={{ shrink: true }}
//                         sx={{
//                           input: { color: '#fff', fontWeight: 500, letterSpacing: 1.2 },
//                           '& .MuiOutlinedInput-root': {
//                             backgroundColor: 'rgba(85, 85, 85, 0.55)',
//                             borderRadius: 3,
//                             boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
//                             '& fieldset': { borderColor: '#555' },
//                             '&:hover fieldset': { borderColor: '#1E90FF' },
//                             '&.Mui-focused fieldset': { borderColor: '#1E90FF', borderWidth: 1.8 },
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: '#aaa',
//                             fontWeight: 600,
//                             letterSpacing: 1.2,
//                           },
//                         }}
//                       />

//                       {/* Start Time */}
//                       <TextField
//                         label="Start Time"
//                         type="time"
//                         fullWidth
//                         value={startTime}
//                         onChange={(e) => setStartTime(e.target.value)}
//                         InputLabelProps={{ shrink: true }}
//                         sx={{
//                           input: { color: '#fff', fontWeight: 500, letterSpacing: 1.2 },
//                           fontSize: { xs: '0.9rem', sm: '1rem' },
//                           '& .MuiOutlinedInput-root': {
//                             backgroundColor: 'rgba(85, 85, 85, 0.55)',
//                             borderRadius: 3,
//                             boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
//                             '& fieldset': { borderColor: '#555' },
//                             '&:hover fieldset': { borderColor: '#1E90FF' },
//                             '&.Mui-focused fieldset': { borderColor: '#1E90FF', borderWidth: 1.8 },
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: '#aaa',
//                             fontWeight: 600,
//                             letterSpacing: 1.2,
//                             fontSize: { xs: '0.9rem', sm: '1rem' },
//                           },
//                         }}
//                       />
//                     </Box>
//                   </Box>




//                 </>


//               )}


//               {step === 2 && (
//                 <>
//                   <Box
//                     sx={{
//                       width: '100%',
//                       maxWidth: {
//                         xs: '100%',   // full width on mobile
//                         sm: '90%',
//                         md: '80%',
//                         lg: '70%',
//                         xl: '60%',
//                       },
//                       mx: 'auto',
//                       px: {
//                         xs: 2,
//                         sm: 3,
//                         md: 4,
//                       },
//                     }}
//                   >


//                     <Box
//                       sx={{
//                         display: 'flex',
//                         flexWrap: 'wrap',
//                         gap: 2,
//                         justifyContent: 'center',
//                         mb: 1,
//                         mt: 5,
//                       }}
//                     >
//                       {durationOptions.map((option) => (
//                         <Button
//                           key={option}
//                           variant={duration === option ? 'contained' : 'outlined'}
//                           onClick={() => handleDurationChange({ target: { value: option } })}
//                           sx={{
//                             letterSpacing: 2,
//                             fontSize: {
//                               xs: '0.9rem',
//                               sm: '1rem',
//                             },
//                             color: 'white',
//                             borderColor: '#555',
//                             backgroundColor: duration === option ? '#1E90FF' : 'transparent',
//                             '&:hover': {
//                               backgroundColor: '#1E90FF',
//                               borderColor: '#1E90FF',
//                             },
//                           }}
//                         >
//                           {option} min
//                         </Button>
//                       ))}
//                     </Box>

//                     <FormHelperText
//                       sx={{
//                         textAlign: 'center',
//                         letterSpacing: 2,
//                         fontSize: {
//                           xs: '0.8rem',
//                           sm: '0.9rem',
//                         },
//                         color: '#aaa',
//                       }}
//                     >
//                       (max 300 minutes)
//                     </FormHelperText>
//                   </Box>

//                   <Typography
//                     variant="body1"
//                     sx={{
//                       textAlign: 'center',
//                       mb: 4,
//                       mt: 4,
//                       letterSpacing: 2,
//                       color: 'white',
//                       fontWeight: 500,
//                       fontSize: {
//                         xs: '0.95rem',
//                         sm: '1.05rem',
//                       },
//                     }}
//                   >
//                     Step {step + 1} of {totalSteps}
//                   </Typography>


//                 </>
//               )}


               
//               {/* {step === 3 && (
//                 <>


//                   <Typography
//                     variant="h6"
//                     sx={{
//                       textAlign: 'center',
//                       letterSpacing: 2,
//                       mb: 10,
//                       color: 'transparent',
//                       backgroundImage: 'linear-gradient(45deg, white, white)',
//                       backgroundClip: 'text',
//                       WebkitBackgroundClip: 'text',
//                       fontStyle: 'italic',
//                     }}
//                   >
//                     Please select a price for the session.
//                   </Typography>

//                   <Box
//                     sx={{
//                       width: '100%',
//                       maxWidth: {
//                         xs: '100%',
//                         sm: '90%',
//                         md: '80%',
//                         lg: '70%',
//                         xl: '60%',
//                       },
//                       mx: 'auto',
//                       px: {
//                         xs: 2,
//                         sm: 3,
//                         md: 4,
//                       },
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         justifyContent: 'center',
//                         gap: 3,
//                         mb: 4,
//                       }}
//                     >
//                       {['goPriceless', 'setPrice'].map((option) => (
//                         <Button
//                           key={option}
//                           variant={goPriceless === (option === 'goPriceless') ? 'contained' : 'outlined'}
//                           onClick={() => handleRadioChange({ target: { value: option } })}
//                           sx={{
//                             letterSpacing: 2,
//                             px: 4,
//                             color: goPriceless === (option === 'goPriceless') ? 'white' : 'inherit',
//                             backgroundColor: goPriceless === (option === 'goPriceless') ? '#1E90FF' : 'transparent',
//                             '&:hover': {
//                               backgroundColor: '#1E90FF',
//                               color: 'white',
//                             },
//                           }}
//                         >
//                           {option === 'goPriceless' ? 'Go Priceless' : 'Set Price'}
//                         </Button>
//                       ))}
//                     </Box>

//                     {!goPriceless && (
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           flexWrap: 'wrap',
//                           gap: 2,
//                           justifyContent: 'center',
//                           mb: 2,
//                         }}
//                       >
//                         {priceOptions.map((option) => (
//                           <Button
//                             key={option}
//                             variant={price === option ? 'contained' : 'outlined'}
//                             onClick={() => handlePriceChange({ target: { value: option } })}
//                             sx={{
//                               letterSpacing: 2,
//                               px: 3,
//                               color: price === option ? 'white' : 'inherit',
//                               backgroundColor: price === option ? '#1E90FF' : 'transparent',
//                               '&:hover': {
//                                 backgroundColor: '#1E90FF',
//                                 color: 'white',
//                               },
//                             }}
//                           >
//                             INR {option}
//                           </Button>
//                         ))}
//                       </Box>
//                     )}

//                     {!goPriceless ? (
//                       <FormHelperText sx={{ letterSpacing: 2, textAlign: 'center' }}>
//                         Please note: Price cannot exceed INR 500.
//                       </FormHelperText>
//                     ) : (
//                       <FormHelperText sx={{ letterSpacing: 2, textAlign: 'center', mb: 3 }}>
//                         Price is set to zero as you chose "Go Priceless".
//                       </FormHelperText>
//                     )}
//                   </Box>

//                   <Typography
//                     variant="body1"
//                     sx={{
//                       textAlign: 'center',
//                       mt: 4,
//                       mb: 4,
//                       letterSpacing: 2,
//                       color: 'white',
//                       fontWeight: 500,
//                       fontSize: {
//                         xs: '0.95rem',
//                         sm: '1.05rem',
//                       },
//                     }}
//                   >
//                     Step {step + 1} of {totalSteps}
//                   </Typography>


//                 </>
//               )
//               } */}

//               <Box
//                 sx={{
//                   display: 'flex',
//                   flexDirection: {
//                     xs: 'column',
//                     sm: 'row',
//                   },
//                   justifyContent: {
//                     xs: 'center',
//                     sm: 'space-between',
//                   },
//                   alignItems: 'center',
//                   gap: 2,
//                   mt: 4,
//                   width: '100%',
//                   maxWidth: {
//                     xs: '100%',
//                     sm: '80%',
//                     md: '80%',  // Reduce width on medium screens
//                     lg: '65%',
//                   },
//                   mx: 'auto', // Horizontally center the box
//                 }}
//               >
//                 <Button
//                   variant="outlined"
//                   onClick={handleBack}
//                   disabled={step === 0 || status === 'success'}
//                   sx={{
//                     width: { xs: '100%', sm: 'auto' },
//                     letterSpacing: 2,
//                     '&:disabled': {
//                       borderColor: '#9e9e9e',
//                       color: '#9e9e9e',
//                     },
//                   }}
//                 >
//                   Back
//                 </Button>

//                 {step < totalSteps - 1 ? (
//                   <Button
//                     variant="contained"
//                     onClick={handleNext}
//                     sx={{
//                       width: { xs: '100%', sm: 'auto' },
//                       letterSpacing: 2,
//                     }}
//                   >
//                     Next
//                   </Button>
//                 ) : (
//                   <Button
//                     variant="contained"
//                     onClick={handlePost}
//                     disabled={status === 'success'}
//                     sx={{
//                       width: { xs: '100%', sm: 'auto' },
//                       backgroundColor: isVerified ? '#1976d2' : '#1E90FF',
//                       color: '#fff',
//                       letterSpacing: 2,
//                       '&:disabled': {
//                         backgroundColor: '#9e9e9e',
//                         color: '#ffffff',
//                       },
//                     }}
//                   >
//                     Submit
//                   </Button>
//                 )}
//               </Box>

//               {status === 'success' && (
//                 <Box
//                   sx={{
//                     textAlign: "center",
//                     mt: 5,
//                     px: 3,
//                     py: 4,
//                     borderRadius: "12px",
//                     backgroundColor: "#001F3F",
//                     boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
//                   }}
//                 >
//                   <CheckCircleIcon sx={{ color: "#4caf50", fontSize: 40, mb: 2 }} />

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       color: "#1E90FF",
//                       letterSpacing: 2,
//                       fontWeight: 700,
//                       fontSize: {
//                         xs: "1.1rem",
//                         sm: "1.3rem",
//                         md: "1.5rem",
//                       },
//                       lineHeight: 1.6,
//                       mb: 1,
//                     }}
//                   >
//                     Session created Successfully!
//                   </Typography>

//                   <Typography
//                     variant="body1"
//                     sx={{
//                       color: "#b0c4de",
//                       letterSpacing: 1.5,
//                       fontSize: {
//                         xs: "0.9rem",
//                         sm: "1rem",
//                         md: "1.1rem",
//                       },
//                       maxWidth: "600px",
//                       margin: "0 auto",
//                     }}
//                   >
//                     Please visit{' '}
//                     <MuiLink
//                       component={Link}
//                       to={
//                         `/my-post-tab-details/${id}`
//                       }
//                       underline="hover"
//                       sx={{ color: "#ffffff", fontWeight: "bold" }}
//                     >
//                       My sessions
//                     </MuiLink>{' '}
//                     to view your updates.
//                   </Typography>

//                   {/* Create New Button */}
//                   <Button
//                     variant="outlined"
//                     onClick={() => window.location.reload()}
//                     sx={{
//                       mt: 3,
//                       color: "#1E90FF",
//                       borderColor: "#1E90FF",
//                       letterSpacing: 2,
//                       '&:hover': {
//                         backgroundColor: "#1E90FF",
//                         color: "#ffffff",
//                       },
//                     }}
//                   >
//                     Create New
//                   </Button>
//                 </Box>
//               )}

//             </Box>

//             {loading && (
//               <Box
//                 sx={{
//                   position: 'fixed',
//                   top: 0,
//                   left: 0,
//                   width: '100vw',
//                   height: '100vh',
//                   backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                   zIndex: 2000,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   backdropFilter: 'blur(3px)',
//                 }}
//               >
//                 <Box sx={{ textAlign: 'center' }}>
//                   <CircularProgress
//                     size={60}
//                     thickness={6}
//                     sx={{
//                       color: 'transparent',
//                       '& .MuiCircularProgress-circle': {
//                         stroke: 'url(#better-gradient)',
//                       },
//                     }}
//                   />

//                   <svg width="0" height="0">
//                     <defs>
//                       <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
//                         <stop offset="0%" stopColor="#f30b96ff" />     {/* pinkish-purple */}
//                         <stop offset="50%" stopColor="#221ce0ff" />     {/* deep lavender */}
//                         <stop offset="100%" stopColor="#0eacebff" />    {/* bright sky blue */}
//                       </linearGradient>
//                     </defs>
//                   </svg>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mt: 2,
//                       color: '#fff',
//                       textShadow: '0 1px 3px rgba(0,0,0,0.7)',
//                     }}
//                   >
//                     Posting Your Session... ({loadingSeconds} sec)
//                   </Typography>
//                 </Box>
//               </Box>
//             )}



//             <Snackbar
//               open={openSnackbar}
//               autoHideDuration={20000}
//               onClose={() => setOpenSnackbar(false)}
//             >
//               <Alert severity="error" sx={{ width: '100%' }} onClose={() => setOpenSnackbar(false)}>
//                 {error}
//               </Alert>
//             </Snackbar>
//           </Container>
//         </Box>
//       </Box>
//       <Footer2 />
//     </div>
//   );
// };

// export default CreateRequest1;


import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import {api} from '../Login/axiosConfig';
import { useAuth } from '../../AuthContext';
import { AppBar, Toolbar, TextField, Button, Grid, Typography, Container, MenuItem, Select, InputLabel, FormControl, Box, Snackbar, Alert, FormHelperText, RadioGroup, FormControlLabel, Radio, Link as MuiLink } from '@mui/material';
import { useParams } from 'react-router-dom';
import GenerateMeetingLinkButton from '../GoogleMeet/GenerateMeetingLinkButton';
import { format } from 'date-fns';
import GenerateZoomMeetingButton from '../Zoom/GenerateZoomMeetingButton';
import ZoomAuthButton from '../Zoom/ZoomAuthButton';
import GenerateMicrosoftTeamsLink from '../Microsoft/GenerateMicrosoftTeamsLink';
import GoogleMeetLogo from '../Post/GoogleMeetImage.png';
import ZoomMeetLogo from '../Post/ZoomMeetImage.png';
import TeamsMeetLogo from '../Post/TeamsMeetImage.png';
import { parseISO } from 'date-fns';
import Header1 from '../Header/Header1';
import Platform from '../Platform/Platform';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link } from 'react-router-dom';
import Footer2 from '../Footer/Footer2';
import { Stack } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CircularProgress from '@mui/material/CircularProgress';

const API_URL = process.env.REACT_APP_API_URL;

const styles = {
  glassBox: {
    backdropFilter: 'blur(15px)',
    backgroundColor: '#000000',
    borderRadius: '16px',
    padding: '2.5rem',
    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.2)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    width: '100%',
    maxWidth: '100%',
    textAlign: 'center',
  },
  logo: {
    width: '160px',
    height: '160px',
    margin: '0 auto 1rem',
  },
  text: {
    color: 'white',
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    width: '100%',
  },
  input: {
    marginBottom: '1rem',
    letterSpacing: 2,
    '& .MuiInputBase-input': {
      color: 'white',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.7)',
      transition: 'color 0.3s',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.5)',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1E90FF',
    },
    '&:hover .MuiInputLabel-root': {
      color: '#1E90FF',
    },
    '& .MuiSelect-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1E90FF',
    },
  },
  dateInput: {
    marginBottom: '1rem',
    '& .MuiInputBase-input': {
      color: 'white',
    },
    '& .MuiInputBase-input::placeholder': {
      color: 'transparent',
      transition: 'color 0.3s',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.7)',
      transition: 'color 0.3s',
    },
    '& .Mui-focused .MuiInputBase-input::placeholder': {
      color: 'white',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.5)',
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1E90FF',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1E90FF',
    },
  },
  button: {
    backgroundColor: '#1E90FF',
    color: 'white',
    marginTop: '1.5rem',
  },

};

const CreateRequest1 = ({ onLogout}) => {
    const [type, setType] = useState("session");

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);

  const { userId } = useAuth();
  const [ppt, setPpt] = useState(null);
const [pptPreview, setPptPreview] = useState(null);
  const { role } = useAuth();
  const [startTime, setStartTime] = useState('');
  const [duration, setDuration] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [maxLimit, setMaxLimit] = useState('');
  const [price, setPrice] = useState(0);
  const [topicName, setTopicName] = useState('');
  const [description, setDescription] = useState('');
  const [sectionId, setSectionId] = useState('');
  const [subsectionId, setSubsectionId] = useState('');
  const [sections, setSections] = useState([]);
  const [subsections, setSubsections] = useState([]);
  const [error, setError] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  // const [language, setLanguage] = useState('');
  const [language, setLanguage] = useState([]);
  const [meetingLink, setMeetingLink] = useState("");
  const [googleMeetLink, setGoogleMeetLink] = useState('');
  const defaultLanguages = [
    { id: 'assamese', name: 'Assamese' },
    { id: 'bengali', name: 'Bengali' },
    { id: 'bodo', name: 'Bodo' },
    { id: 'dogri', name: 'Dogri' },
    { id: 'gujarati', name: 'Gujarati' },
    { id: 'hindi', name: 'Hindi' },
    { id: 'kannada', name: 'Kannada' },
    { id: 'kashmiri', name: 'Kashmiri' },
    { id: 'konkani', name: 'Konkani' },
    { id: 'maithili', name: 'Maithili' },
    { id: 'malayalam', name: 'Malayalam' },
    { id: 'manipuri', name: 'Manipuri' },
    { id: 'marathi', name: 'Marathi' },
    { id: 'nepali', name: 'Nepali' },
    { id: 'odia', name: 'Odia' },
    { id: 'punjabi', name: 'Punjabi' },
    { id: 'sanskrit', name: 'Sanskrit' },
    { id: 'santali', name: 'Santali' },
    { id: 'sindhi', name: 'Sindhi' },
    { id: 'telugu', name: 'Telugu' },
    { id: 'tamil', name: 'Tamil' },
    { id: 'urdu', name: 'Urdu' },
    { id: 'english', name: 'English' },
  ];
  const [languages, setLanguages] = useState(defaultLanguages);  // State for languages
  const [platform, setPlatform] = useState("");
  const [isValid, setIsValid] = useState(null);
  const [status, setStatus] = useState(null);
  const [id, setId] = useState(null);
  const [title, setTitle] = useState('');
  const location = useLocation();
  


  // to track the validity of the link
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const [goPriceless, setGoPriceless] = useState(false);


  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(false); // to track check status
  const [loadingSeconds, setLoadingSeconds] = useState(0);

  const [userData, setUserData] = useState({
    name: '',
    surname: '',
    image: '',
    role: '',
  });

  const [media, setMedia] = useState(null);
  const [mediaPreview, setMediaPreview] = useState(null);

  const handlePptChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  // local preview (before upload)
  const url = URL.createObjectURL(file);
  setPptPreview(url);

  // store file for upload
  setPpt(file);
};
  useEffect(() => {
    let timer;

    if (loading) {
      setLoadingSeconds(0); // reset timer
      timer = setInterval(() => {
        setLoadingSeconds(prev => prev + 1);
      }, 1000);
    } else {
      clearInterval(timer);
      setLoadingSeconds(0); // optional reset after done
    }

    return () => clearInterval(timer); // cleanup on unmount or loading = false
  }, [loading]);


  useEffect(() => {
    if (role === 'expert' || role === 'admin') {
      setIsVerified(true);
    }
  }, [role]);




  useEffect(() => {
    api.get(`${API_URL}/list_sections_and_subsections/?user_id=${userId}`)
      .then((response) => {
        const transformedSections = Object.entries(response.data.sections).map(([sectionName, sectionData]) => ({
          sectionId: sectionData.section_id,
          sectionName,
          subsections: sectionData.subsections,
        }));
        setSections(transformedSections);


        const apiLanguages = response.data.languages;
 if (Array.isArray(apiLanguages) && apiLanguages.length > 0) {
  const transformedLanguages = apiLanguages.map((lang, index) => {
    if (typeof lang === 'string') {
      return {
        id: lang.toLowerCase().replace(/\s+/g, '_'),
        name: lang,
      };
    }
    return {
      id: lang?.id || `${index}`,
      name: lang?.name || lang?.label || lang?.value || '',
    };
  }).filter((lang) => lang.name);

  setLanguages(transformedLanguages);
} else {
  setLanguages([]); // ❗ no default fallback
}
      })
      .catch((error) => {
        console.error('Error fetching sections:', error);
      });
  }, [userId]);

  useEffect(() => {
    if (!userId) {
      return;
    }

    // Fetch user data
    api.get(`${API_URL}/get_user_data/?user_id=${userId}`)
      .then((response) => {
        setUserData(response.data);
      })
      .catch((err) => console.error(err));
  }, [userId]);


  const showAlert = () => {
    const alertDiv = document.createElement('div');

    alertDiv.textContent = isVerified
      ? 'Session created successfully.'
      : 'Request session created successfully.';
    alertDiv.style.position = 'fixed';
    alertDiv.style.top = '100px';
    alertDiv.style.left = '50%';
    alertDiv.style.transform = 'translateX(-50%)';
    alertDiv.style.padding = '50px 100px';
    alertDiv.style.backgroundColor = '#1E90FF';
    alertDiv.style.color = 'black';
    alertDiv.style.borderRadius = '5px';
    alertDiv.style.zIndex = '9999';
    alertDiv.style.fontSize = '16px';

    document.body.appendChild(alertDiv);

    setTimeout(() => {
      alertDiv.remove();
    }, 20000);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const getMediaTypeFromFile = (file) => {
    const ext = file.name.split('.').pop().toLowerCase();
    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
    const videoExts = ['mp4', 'mov', 'avi', 'mkv'];

    if (imageExts.includes(ext)) return 'image';
    if (videoExts.includes(ext)) return 'video';
    return 'unknown';
  };



  const handleUploadToCloudinary = async (file) => {
    const cloudName = 'dywuk1huu'; // Replace with your actual Cloudinary cloud name
    const uploadPreset = 'anthra_cloud_01'; // Replace with your Cloudinary unsigned upload preset

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', uploadPreset);

    try {
      const response = await api.post(
        `https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`,
        formData
      );

      return response.data.secure_url;
    } catch (error) {
      console.error('Cloudinary upload failed:', error);
      throw error;
    }
  };

  const MAX_FILE_SIZE = 100 * 1024 * 1024; // 5 MB

const ALLOWED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "video/mp4",
  "video/webm",
  "video/quicktime", // .mov
  "application/pdf",

  // PPT
  "application/vnd.ms-powerpoint", // .ppt
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

const validateFile = (file) => {
  if (!file) return "No file selected";

  if (!ALLOWED_TYPES.includes(file.type)) {
    return "Only images and videos are allowed";
  }

  if (file.size > MAX_FILE_SIZE) {
    return "File size must be less than 5 MB";
  }

  return null;
};



  const getPresignedUrl = async (file) => {
  const res = await api.post(`${API_URL}/api/presigned-url/`, {
    file_name: file.name,
    file_type: file.type,
    file_size: file.size,
  });
  console.log("FINAL DATA BEING SENT:", res.data);

  return res.data;
};


// const uploadToS3 = async (file) => {
//   const error = validateFile(file);
//   if (error) {
//     alert(error); // or MUI Snackbar
//     return null;
//   }

//   const { upload_url, key } = await getPresignedUrl(file);

//   await axios.put(upload_url, file, {
//     headers: {
//       "Content-Type": file.type,
//     },
//   });

//   return key;
// };

const uploadToS3 = async (file) => {
  console.log("Uploading file:", file.name, file.type, file.size);

  const error = validateFile(file);
  if (error) {
    console.log("Validation error:", error);
    alert(error);
    return null;
  }

  const { upload_url, key } = await getPresignedUrl(file);

  console.log("Presigned URL:", upload_url);
  console.log("Generated Key:", key);

  await axios.put(upload_url, file, {
    headers: {
      "Content-Type": file.type,
    },
  });

  console.log("Upload success!");

  return key;
};



  // const uploadToS3 = async (file) => {
  //     if (!file) return null;
  
  //     const formData = new FormData();
  //     formData.append("file", file);
  
  //     const uploadRes = await api.post(`${API_URL}/api/upload-s3/`, formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });
  //     return uploadRes.data.key;
  //   };

  // const cloudName = 'dywuk1huu';
  //   const uploadPreset = 'anthra_cloud_01';

  const handlePost = async () => {
    console.log("PPT file:", ppt);

    const requiredFields = [
      { field: description, fieldName: "Description" },
      { field: language, fieldName: "Language" },
      { field: duration, fieldName: "Duration" },
      // { field: price, fieldName: "Price" },
      { field: selectedDate, fieldName: "Select date" },
      { field: startTime, fieldName: "Start Time" },
    ];


    for (let { field, fieldName } of requiredFields) {
      if (fieldName === 'Price') {
        if (!goPriceless && (field === undefined || field === null || field.toString().trim() === '' || Number(field) === 0)) {
          setError('Price is required unless you choose Go Priceless.');
          setOpenSnackbar(true);
          return;
        }
        continue;
      }

      if (field === undefined || field === null || field.toString().trim() === "") {
        setError(`${fieldName} is required.`);
        setOpenSnackbar(true);
        return;
      }
    }


    // Validate startTime format (HH:mm) before passing to postData
    if (startTime && !/^\d{2}:\d{2}$/.test(startTime)) {
      setError('Start Time must be in the format HH:mm.');
      setOpenSnackbar(true);
      return;
    }


    if (startTime) {
      const today = new Date();
      const timeParts = startTime.split(':');
      today.setHours(timeParts[0], timeParts[1]);

      const formattedStartTime = format(today, "yyyy-MM-dd'T'HH:mm:ss");

      const parsedStartTime = parseISO(formattedStartTime);

      if (isNaN(parsedStartTime)) {
        setError('Invalid start time.');
        setOpenSnackbar(true);
        return;
      }
    }



    // Validate the duration
    if (duration > 300) {
      setError('Duration cannot exceed 300 minutes.');
      setOpenSnackbar(true);
      return;
    }

    

    
    setLoading(true);

    let mediaKey = null;
    let mediaType = null;
    let pptKey = null;

if (ppt) {
  console.log("Uploading PPT...");
  pptKey = await uploadToS3(ppt);
  console.log("Returned PPT Key:", pptKey);
}

    if (media) {
      try {
        mediaType = getMediaTypeFromFile(media); // detect manually
        mediaKey = await uploadToS3(media);
        // mediaUrl = await handleUploadToCloudinary(media); // upload to cloudinary
      } catch (err) {
        setError("Failed to upload media.");
        setOpenSnackbar(true);
        setLoading(false);
        return;
      }
    }


    const selectedSection = sections.find(section => section.sectionId === sectionId);
    const sectionName = selectedSection ? selectedSection.sectionName : '';

    const selectedSubsection = subsections.find(subsection => subsection.id === subsectionId);
    const subsectionName = selectedSubsection ? selectedSubsection.name : '';

    const formData = new FormData();

    const selectedDateTime = `${selectedDate}T${startTime}`;

    const data = {
      user_id: userId,
      section_id: sectionId,
      section_name: sectionName,
      subsection_id: subsectionId,
      subsection_name: subsectionName,
      startTime: startTime,
      duration: duration,
      selectedDate: selectedDate,
      selected_date_and_time: selectedDateTime,
      max_limit: maxLimit,
      price: price,
      title: topicName,
      description: description,
      language: language,
      media_key: mediaKey || null,
      media_type: mediaType || null,
      ppt_key: pptKey || null, 
      type:type,
    };

  


    const endpoint = isVerified ? 'create_post' : 'create_request';
    const subscriptionError = isVerified
      ? 'You need an active subscription to post.'
      : 'You need an active subscription to request.';
    const generalError = isVerified
      ? 'An error occurred while posting. Please try again later.'
      : 'An error occurred while creating request. Please try again later.';

    setLoading(true);

    api.post(`${API_URL}/${endpoint}/`, data, {
      // headers: {
      //   'Content-Type': 'multipart/form-data',
      // },
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        setStatus('success');
        setId(response.data.id);
      })
      .catch((error) => {
        // console.error('Error sending data:', error);
        console.error("Error sending data:", error);

  if (error.response) {
    console.log("SERVER ERROR DATA:", error.response.data);  // ADD THIS
  }
        if (error.response && error.response.status === 403) {
          setError(subscriptionError);
        } else {
          setError(generalError);
        }
        setOpenSnackbar(true);
      })
      .finally(() => {
        setLoading(false); // stop loader
      });
  };


  const handleChange = (event) => {
    setLanguage(event.target.value);
  };

  const handleRedirect = () => {
    navigate('/requesting-guidelines');  // Redirect to meeting guidelines page
  };


  const handleDurationChange = (e) => {
    setDuration(e.target.value);
  };

  const durationOptions = [];
  for (let i = 30; i <= 300; i += 30) {
    durationOptions.push(i);
  }

  const handleMaxLimitChange = (e) => {
    setMaxLimit(e.target.value);
  };

  const maxLimitOptions = [];
  for (let i = 10; i <= 100; i += 10) {
    maxLimitOptions.push(i);
  }

  const handlePriceChange = (e) => {
    setPrice(e.target.value);
  };

  // Generate price options based on intervals
  const priceOptions = [];

  // Interval of 10 from 0 to 100
  for (let i = 10; i <= 100; i += 10) {
    priceOptions.push(i);
  }

  // Interval of 25 from 100 to 300
  for (let i = 125; i <= 300; i += 25) {
    priceOptions.push(i);
  }

  // Interval of 50 from 300 to 500
  for (let i = 350; i <= 500; i += 50) {
    priceOptions.push(i);
  }

  const handleRadioChange = (event) => {
    const isGoPriceless = event.target.value === "goPriceless";
    setGoPriceless(isGoPriceless);
    if (isGoPriceless) {
      setPrice(0); // Set price to 0 if "Go priceless" is selected
    } else {
      setPrice(''); // Reset the price selection when going back to "Set Price"
    }
  };

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   setMedia(file);
  //   setMediaPreview(URL.createObjectURL(file));
  // };


  // const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  if (file.size > MAX_FILE_SIZE) {
    alert("File size must be less than 5 MB");
    event.target.value = ""; // reset input
    return;
  }

  setMedia(file);
  setMediaPreview(URL.createObjectURL(file));
};


  const [step, setStep] = useState(0);
  const totalSteps = 3;

  const validateStep = () => {
    if (step === 0) {
      if (!topicName.trim()) {
        setError('Session title is required.');
        setOpenSnackbar(true);
        return false;
      }
      if (!description.trim()) {
        setError('Description is required.');
        setOpenSnackbar(true);
        return false;
      }
    }

    if (step === 1) {
      if (!language) {
        setError('Please select a language.');
        setOpenSnackbar(true);
        return false;
      }
    }

    if (step === 2) {
      if (!selectedDate) {
        setError('Please select a date.');
        setOpenSnackbar(true);
        return false;
      }
      if (!startTime) {
        setError('Please select a start time.');
        setOpenSnackbar(true);
        return false;
      }
      if (!duration) {
        setError('Please select a duration.');
        setOpenSnackbar(true);
        return false;
      }
    }

    if (step === 3) {
      if (!goPriceless && (!price || Number(price) <= 0)) {
        setError('Please select a price or choose Go Priceless.');
        setOpenSnackbar(true);
        return false;
      }
    }

    return true;
  };

  const handleNext = () => {
    if (step < totalSteps - 1 && validateStep()) {
      setStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (step > 0) setStep((prev) => prev - 1);
  };

  const isActive = (path) => location.pathname === path;


  return (
    <div style={{ backgroundColor: '#000000', minHeight: '100vh', color: '#ffffff', }}>
      <Box
        sx={{
          position: 'fixed', // or 'relative' / 'sticky' based on your layout
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 1300, // higher than MUI drawers (default is 1200)
        }}
      >
        <Header1 onLogout={onLogout} />
      </Box>

  
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box>
          <Platform userId={userId} onLogout={onLogout} />
        </Box>

        <Box position="static" color="primary" sx={{ mt: 5, backgroundColor: '#000000' }}>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4, mb:2}}>
        <Button
          variant={type === "session" ? "contained" : "outlined"}
          onClick={() => setType("session")}
        >
          Session
        </Button>
        <Button
          variant={type === "ai_immersion" ? "contained" : "outlined"}
          onClick={() => setType("ai_immersion")}
        >
          AI Immersion
        </Button>
      </Box>

          <Toolbar>
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', gap: 2 }}>

              {/* Single Button */}
              <Button
                variant={isActive('/platform/create') ? 'contained' : 'outlined'}
                color={isActive('/platform/create') ? 'secondary' : 'inherit'}
                onClick={() => navigate('/platform/create')}
                sx={{
                  borderRadius: '20px',
                  textTransform: 'none',
                  fontWeight: 'bold',
                  px: 3,
                  py: 1,
                  bgcolor: isActive('/platform/create') ? 'secondary.main' : 'transparent',
                  color: isActive('/platform/create') ? 'white' : 'inherit',
                  border: '2px solid',
                  borderColor: isActive('/platform/create') ? 'primary.main' : 'inherit',
                  '&:hover': {
                    bgcolor: isActive('/platform/create') ? 'secondary.dark' : 'action.hover',
                    borderColor: 'primary.main',
                  },
                }}
              >
                Single
              </Button>

              {/* Multiple Button */}
              <Button
                variant={isActive('/platform/create-series') ? 'contained' : 'outlined'}
                color={isActive('/platform/create-series') ? 'secondary' : 'inherit'}
                onClick={() => navigate('/platform/create-series')}
                sx={{
                  borderRadius: '20px',
                  textTransform: 'none',
                  fontWeight: 'bold',
                  px: 3,
                  py: 1,
                  bgcolor: isActive('/platform/create-series') ? 'secondary.main' : 'transparent',
                  color: isActive('/platform/create-series') ? 'white' : 'inherit',
                  border: '2px solid',
                  borderColor: isActive('/platform/create-series') ? 'primary.main' : 'inherit',
                  '&:hover': {
                    bgcolor: isActive('/platform/create-series') ? 'secondary.dark' : 'action.hover',
                    borderColor: 'primary.main',
                  },
                }}
              >
                Multiple
              </Button>

            </Box>
          </Toolbar>
        </Box>



        <Box>
          <Container maxWidth="lg" sx={{
            marginBottom: { xs: '2rem', sm: '3rem', lg: '5rem' }, padding: '0 2rem',
            // mt: {
            //   xs: 10,   // Mobile
            //   sm: 15,   // Small screens
            //   md: 20,   // Medium screens
            //   lg: 25,   // Large screens
            //   xl: 30,   // Extra-large screens
            // }
          }}>
            <Box sx={{
              padding: '2rem',
              borderRadius: '8px',
              backgroundColor: '#000000',
              transition: 'border-color 0.3s ease',
              '&:hover': { borderColor: '#1E90FF' },
            }}>
              <Typography variant="h4" component="h1" sx={{
                marginTop: '1.5rem',
                textAlign: 'center',
                letterSpacing: 5,
                mb: 2,
                color: 'transparent',
                backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
              }}>
                Hi {userData.name},
              </Typography>

              {step === 0 && (

                <>


                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: 'center',
                      letterSpacing: 2,
                      mb: { xs: 6, sm: 8, md: 10 },
                      color: 'transparent',
                      backgroundImage: 'linear-gradient(45deg, white, white)',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      fontStyle: 'italic',
                      fontWeight: 500,
                      fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' },
                      px: 2,
                    }}
                  >
                    Tell us what would you like to{' '}
                    share in a real-time knowledge session.
                  </Typography>

                  <Box
                    sx={{
                      width: { xs: '100%', sm: '95%', md: '90%', lg: '80%', xl: '70%' },
                      mx: 'auto',
                      px: { xs: 2, sm: 3, md: 4 },
                    }}
                  >
                    {/* Session Title or Topic */}
                    <TextField
                      label={isVerified ? 'Session Title' : 'Ask us anything...'}
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={2}
                      value={topicName}
                      onChange={(e) =>
                        e.target.value.length <= 100 && setTopicName(e.target.value)
                      }
                      helperText={`${topicName.length}/100 characters`}
                      inputProps={{
                        maxLength: 100,
                        style: { letterSpacing: 1.5, paddingTop: 18 },
                      }}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          letterSpacing: 1.5,
                          backgroundColor: 'background.default',
                          px: 0.5,
                          transform: 'translate(14px, -9px) scale(0.75)',
                        },
                      }}
                      FormHelperTextProps={{
                        sx: {
                          letterSpacing: 1.5,
                          color: topicName.length > 100 ? 'warning.main' : 'text.secondary',
                        },
                      }}
                      sx={{
                        mb: 3,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 3,
                          backgroundColor: 'background.paper',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                          '&:hover fieldset': { borderColor: 'primary.main' },
                          '&.Mui-focused fieldset': { borderColor: 'primary.dark', borderWidth: 1.5 },
                        },
                      }}
                    />

                    {/* Description */}
                    <TextField
                      label={isVerified ? 'Brief Description' : 'Ask us anything...'}
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      value={description}
                      onChange={(e) =>
                        e.target.value.length <= 500 && setDescription(e.target.value)
                      }
                      helperText={`${description.length}/500 characters`}
                      inputProps={{
                        maxLength: 500,
                        style: { letterSpacing: 1.5, paddingTop: 18 },
                      }}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          letterSpacing: 1.5,
                          backgroundColor: 'background.default',
                          px: 0.5,
                          transform: 'translate(14px, -9px) scale(0.75)',
                        },
                      }}
                      FormHelperTextProps={{
                        sx: {
                          letterSpacing: 1.5,
                          color: description.length > 450 ? 'warning.main' : 'text.secondary',
                        },
                      }}
                      sx={{
                        mb: 4,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 3,
                          backgroundColor: 'background.paper',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                          '&:hover fieldset': { borderColor: 'primary.main' },
                          '&.Mui-focused fieldset': { borderColor: 'primary.dark', borderWidth: 1.5 },
                        },
                      }}
                    />

                    {/* Media Preview ABOVE upload button */}
                    {mediaPreview && (
                      <Box
                        sx={{
                          mb: 3,
                          borderRadius: 3,
                          overflow: 'hidden',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          maxHeight: 1000,
                          maxWidth: '100%',
                          mx: 'auto',
                        }}
                      >
                        {media?.type.startsWith('image/') ? (
                          <img
                            src={mediaPreview}
                            alt="Preview"
                            style={{ width: '100%', objectFit: 'contain', display: 'block' }}
                          />
                        ) : (
                          <video
                            controls
                            src={mediaPreview}
                            style={{ width: '100%', display: 'block' }}
                          />
                        )}
                      </Box>
                    )}
                    {/* PPT Preview */}
{/* {pptPreview && (
  <Box
    sx={{
      mb: 3,
      borderRadius: 3,
      overflow: "hidden",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      maxHeight: 500,
      maxWidth: "100%",
      mx: "auto",
    }}
  >
    <iframe
      src={pptPreview}
      width="100%"
      height="500px"
      title="ppt-preview"
    />
  </Box>
)} */}
                  

 {/* <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 3 }}> */}

  {/* <Button
    component="label"
    variant="contained"
    startIcon={<CloudUploadIcon />}
    sx={{
      px: 4,
      py: 1.5,
      borderRadius: 3,
      textTransform: "none",
      fontWeight: 600,
      backgroundColor: "primary.main",
      flex: 1,
    }}
  >
    <Stack alignItems="flex-start">
      <Typography sx={{ fontWeight: 600 }}>Upload Media</Typography>
      <Typography variant="caption">
        Max File Size: 5 MB (Image / Video accepted)
      </Typography>
    </Stack>

    <input
      type="file"
      accept="image/*,video/*"
      hidden
      onChange={handleFileChange}
    />
  </Button>  */}


  {/* PPT UPLOAD */}
  {/* <Button
    component="label"
    variant="outlined"
    startIcon={<CloudUploadIcon />}
    sx={{
      px: 4,
      py: 1.5,
      borderRadius: 3,
      textTransform: "none",
      fontWeight: 600,
      flex: 1,
      borderColor: "#1E90FF",
      color: "#1E90FF",
    }}
  >
    <Stack alignItems="flex-start">
      <Typography sx={{ fontWeight: 600 }}>Upload PPT / PDF</Typography>
      <Typography variant="caption">
        Presentation file
      </Typography>
    </Stack>

    <input
      type="file"
      accept=".pdf,.ppt,.pptx"
      hidden
      onChange={handlePptChange}
    />
  </Button> */}

{/* </Box> */}


                    {/* File Upload Button */}
                    <Button
                      component="label"
                      variant="contained"
                      startIcon={<CloudUploadIcon />}
                      sx={{
                        mb: 3,
                        px: 4,
                        py: 1.5,
                        borderRadius: 3,
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '1rem',
                        backgroundColor: 'primary.main',
                        '&:hover': {
                          backgroundColor: 'primary.dark',
                        },
                        boxShadow: '0 2px 8px rgba(25, 118, 210, 0.4)',
                      }}
                    >
                      <Stack direction="column" alignItems="flex-start" spacing={0.3}>
                        <Typography variant="body1" sx={{ fontWeight: 600, color: 'whitesmoke' }}>
                          Upload Media
                        </Typography>
                        <Typography variant="caption">
        Max File Size: 5 MB (Image / Video accepted)
      </Typography>
                        
                      </Stack>
                      <input
                        type="file"
                        accept="image/*,video/*"
                        hidden
                        onChange={handleFileChange}
                      />
                    </Button>
                  </Box>

                  <Typography
                    variant="body1"
                    sx={{
                      textAlign: 'center',
                      mb: 4,
                      letterSpacing: 2,
                      color: 'white',
                      fontWeight: 500,
                      fontSize: {
                        xs: '0.95rem',
                        sm: '1.05rem',
                      },
                    }}
                  >
                    Step {step + 1} of {totalSteps}
                  </Typography>



                </>

              )}




              {step === 1 && (
                <>
                  <Box
                    sx={{
                      width: {
                        xs: '100%',
                        sm: '100%',
                        md: '80%',
                        lg: '70%',
                        xl: '60%',
                      },
                      mx: 'auto',
                      px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: 'center',
                        letterSpacing: 2,
                        mb: 5,
                        color: 'transparent',
                        backgroundImage: 'linear-gradient(45deg, white, white)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        fontStyle: 'italic',
                        fontSize: {
                          xs: '1rem',
                          sm: '1.2rem',
                          md: '1.4rem',
                        },
                      }}
                    >
                      Please select the language in which you will be communicating during the session.
                    </Typography>

                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 2,
                        justifyContent: 'center',
                        mb: 4,
                      }}
                    >
                      {languages.length > 0 ? (
                        languages.map((lang) => (
                          <Button
                            key={lang.id}
                            variant={language === lang.name ? 'contained' : 'outlined'}
                            onClick={() => handleChange({ target: { value: lang.name } })}
                            sx={{
                              letterSpacing: 2,
                              color: 'white',
                              borderColor: '#555',
                              backgroundColor:
                                language === lang.name ? '#1E90FF' : 'transparent',
                              '&:hover': {
                                backgroundColor: '#1E90FF',
                                borderColor: '#1E90FF',
                              },
                            }}
                          >
                            {lang.name}
                          </Button>
                        ))
                      ) : (
                        <Typography
                          variant="body2"
                          sx={{ color: '#ccc', textAlign: 'center', width: '100%' }}
                        >
                          No language options are available right now. Please try again later.
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  <Typography
                    variant="body1"
                    sx={{
                      textAlign: 'center',
                      mb: 4,
                      mt: 4,
                      letterSpacing: 2,
                      color: 'white',
                      fontWeight: 500,
                      fontSize: {
                        xs: '0.95rem',
                        sm: '1.05rem',
                      },
                    }}
                  >
                    Step {step + 1} of {totalSteps}
                  </Typography>


                </>
              )}


              {step === 2 && (
                <>
                  <Box
                    sx={{
                      width: {
                        xs: '100%',
                        sm: '100%',
                        md: '80%',
                        lg: '70%',
                        xl: '60%',
                      },
                      mx: 'auto',
                      px: { xs: 2, sm: 3, md: 4 },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: 'center',
                        letterSpacing: 2,
                        mb: { xs: 5, sm: 6, md: 8 },
                        color: 'transparent',
                        backgroundImage: 'linear-gradient(45deg, white, white)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        fontStyle: 'italic',
                        fontWeight: 600,
                        fontSize: { xs: '1rem', sm: '1.2rem', md: '1.4rem' },
                        userSelect: 'none',
                      }}
                    >
                      Please select an available date, time and duration for the session.
                    </Typography>

                    <Box
                      sx={{
                        display: { xs: 'block', md: 'flex' },
                        gap: { xs: 3, md: 4 },
                        alignItems: 'center',
                      }}
                    >
                      {/* Date Picker */}
                      <TextField
                        label="Select Date"
                        type="date"
                        fullWidth
                        value={selectedDate}
                        onChange={handleDateChange}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          input: { color: '#fff', fontWeight: 500, letterSpacing: 1.2 },
                          '& .MuiOutlinedInput-root': {
                            backgroundColor: 'rgba(85, 85, 85, 0.55)',
                            borderRadius: 3,
                            boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
                            '& fieldset': { borderColor: '#555' },
                            '&:hover fieldset': { borderColor: '#1E90FF' },
                            '&.Mui-focused fieldset': { borderColor: '#1E90FF', borderWidth: 1.8 },
                          },
                          '& .MuiInputLabel-root': {
                            color: '#aaa',
                            fontWeight: 600,
                            letterSpacing: 1.2,
                          },
                        }}
                      />

                      {/* Start Time */}
                      <TextField
                        label="Start Time"
                        type="time"
                        fullWidth
                        value={startTime}
                        onChange={(e) => setStartTime(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          input: { color: '#fff', fontWeight: 500, letterSpacing: 1.2 },
                          fontSize: { xs: '0.9rem', sm: '1rem' },
                          '& .MuiOutlinedInput-root': {
                            backgroundColor: 'rgba(85, 85, 85, 0.55)',
                            borderRadius: 3,
                            boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
                            '& fieldset': { borderColor: '#555' },
                            '&:hover fieldset': { borderColor: '#1E90FF' },
                            '&.Mui-focused fieldset': { borderColor: '#1E90FF', borderWidth: 1.8 },
                          },
                          '& .MuiInputLabel-root': {
                            color: '#aaa',
                            fontWeight: 600,
                            letterSpacing: 1.2,
                            fontSize: { xs: '0.9rem', sm: '1rem' },
                          },
                        }}
                      />
                    </Box>
                  </Box>




                </>


              )}


              {step === 2 && (
                <>
                  <Box
                    sx={{
                      width: '100%',
                      maxWidth: {
                        xs: '100%',   // full width on mobile
                        sm: '90%',
                        md: '80%',
                        lg: '70%',
                        xl: '60%',
                      },
                      mx: 'auto',
                      px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                      },
                    }}
                  >


                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 2,
                        justifyContent: 'center',
                        mb: 1,
                        mt: 5,
                      }}
                    >
                      {durationOptions.map((option) => (
                        <Button
                          key={option}
                          variant={duration === option ? 'contained' : 'outlined'}
                          onClick={() => handleDurationChange({ target: { value: option } })}
                          sx={{
                            letterSpacing: 2,
                            fontSize: {
                              xs: '0.9rem',
                              sm: '1rem',
                            },
                            color: 'white',
                            borderColor: '#555',
                            backgroundColor: duration === option ? '#1E90FF' : 'transparent',
                            '&:hover': {
                              backgroundColor: '#1E90FF',
                              borderColor: '#1E90FF',
                            },
                          }}
                        >
                          {option} min
                        </Button>
                      ))}
                    </Box>

                    <FormHelperText
                      sx={{
                        textAlign: 'center',
                        letterSpacing: 2,
                        fontSize: {
                          xs: '0.8rem',
                          sm: '0.9rem',
                        },
                        color: '#aaa',
                      }}
                    >
                      (max 300 minutes)
                    </FormHelperText>
                  </Box>

                  <Typography
                    variant="body1"
                    sx={{
                      textAlign: 'center',
                      mb: 4,
                      mt: 4,
                      letterSpacing: 2,
                      color: 'white',
                      fontWeight: 500,
                      fontSize: {
                        xs: '0.95rem',
                        sm: '1.05rem',
                      },
                    }}
                  >
                    Step {step + 1} of {totalSteps}
                  </Typography>


                </>
              )}


               
              {/* {step === 3 && (
                <>


                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: 'center',
                      letterSpacing: 2,
                      mb: 10,
                      color: 'transparent',
                      backgroundImage: 'linear-gradient(45deg, white, white)',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      fontStyle: 'italic',
                    }}
                  >
                    Please select a price for the session.
                  </Typography>

                  <Box
                    sx={{
                      width: '100%',
                      maxWidth: {
                        xs: '100%',
                        sm: '90%',
                        md: '80%',
                        lg: '70%',
                        xl: '60%',
                      },
                      mx: 'auto',
                      px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 3,
                        mb: 4,
                      }}
                    >
                      {['goPriceless', 'setPrice'].map((option) => (
                        <Button
                          key={option}
                          variant={goPriceless === (option === 'goPriceless') ? 'contained' : 'outlined'}
                          onClick={() => handleRadioChange({ target: { value: option } })}
                          sx={{
                            letterSpacing: 2,
                            px: 4,
                            color: goPriceless === (option === 'goPriceless') ? 'white' : 'inherit',
                            backgroundColor: goPriceless === (option === 'goPriceless') ? '#1E90FF' : 'transparent',
                            '&:hover': {
                              backgroundColor: '#1E90FF',
                              color: 'white',
                            },
                          }}
                        >
                          {option === 'goPriceless' ? 'Go Priceless' : 'Set Price'}
                        </Button>
                      ))}
                    </Box>

                    {!goPriceless && (
                      <Box
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: 2,
                          justifyContent: 'center',
                          mb: 2,
                        }}
                      >
                        {priceOptions.map((option) => (
                          <Button
                            key={option}
                            variant={price === option ? 'contained' : 'outlined'}
                            onClick={() => handlePriceChange({ target: { value: option } })}
                            sx={{
                              letterSpacing: 2,
                              px: 3,
                              color: price === option ? 'white' : 'inherit',
                              backgroundColor: price === option ? '#1E90FF' : 'transparent',
                              '&:hover': {
                                backgroundColor: '#1E90FF',
                                color: 'white',
                              },
                            }}
                          >
                            INR {option}
                          </Button>
                        ))}
                      </Box>
                    )}

                    {!goPriceless ? (
                      <FormHelperText sx={{ letterSpacing: 2, textAlign: 'center' }}>
                        Please note: Price cannot exceed INR 500.
                      </FormHelperText>
                    ) : (
                      <FormHelperText sx={{ letterSpacing: 2, textAlign: 'center', mb: 3 }}>
                        Price is set to zero as you chose "Go Priceless".
                      </FormHelperText>
                    )}
                  </Box>

                  <Typography
                    variant="body1"
                    sx={{
                      textAlign: 'center',
                      mt: 4,
                      mb: 4,
                      letterSpacing: 2,
                      color: 'white',
                      fontWeight: 500,
                      fontSize: {
                        xs: '0.95rem',
                        sm: '1.05rem',
                      },
                    }}
                  >
                    Step {step + 1} of {totalSteps}
                  </Typography>


                </>
              )
              } */}

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: {
                    xs: 'column',
                    sm: 'row',
                  },
                  justifyContent: {
                    xs: 'center',
                    sm: 'space-between',
                  },
                  alignItems: 'center',
                  gap: 2,
                  mt: 4,
                  width: '100%',
                  maxWidth: {
                    xs: '100%',
                    sm: '80%',
                    md: '80%',  // Reduce width on medium screens
                    lg: '65%',
                  },
                  mx: 'auto', // Horizontally center the box
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleBack}
                  disabled={step === 0 || status === 'success'}
                  sx={{
                    width: { xs: '100%', sm: 'auto' },
                    letterSpacing: 2,
                    '&:disabled': {
                      borderColor: '#9e9e9e',
                      color: '#9e9e9e',
                    },
                  }}
                >
                  Back
                </Button>

                {step < totalSteps - 1 ? (
                  <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{
                      width: { xs: '100%', sm: 'auto' },
                      letterSpacing: 2,
                    }}
                  >
                    Next
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    onClick={handlePost}
                    disabled={status === 'success'}
                    sx={{
                      width: { xs: '100%', sm: 'auto' },
                      backgroundColor: isVerified ? '#1976d2' : '#1E90FF',
                      color: '#fff',
                      letterSpacing: 2,
                      '&:disabled': {
                        backgroundColor: '#9e9e9e',
                        color: '#ffffff',
                      },
                    }}
                  >
                    Submit
                  </Button>
                )}
              </Box>

              {status === 'success' && (
                <Box
                  sx={{
                    textAlign: "center",
                    mt: 5,
                    px: 3,
                    py: 4,
                    borderRadius: "12px",
                    backgroundColor: "#001F3F",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <CheckCircleIcon sx={{ color: "#4caf50", fontSize: 40, mb: 2 }} />

                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1E90FF",
                      letterSpacing: 2,
                      fontWeight: 700,
                      fontSize: {
                        xs: "1.1rem",
                        sm: "1.3rem",
                        md: "1.5rem",
                      },
                      lineHeight: 1.6,
                      mb: 1,
                    }}
                  >
                    Session created Successfully!
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: "#b0c4de",
                      letterSpacing: 1.5,
                      fontSize: {
                        xs: "0.9rem",
                        sm: "1rem",
                        md: "1.1rem",
                      },
                      maxWidth: "600px",
                      margin: "0 auto",
                    }}
                  >
                    Please visit{' '}
                    <MuiLink
                      component={Link}
                      to={
                        `/my-post-tab-details/${id}`
                      }
                      underline="hover"
                      sx={{ color: "#ffffff", fontWeight: "bold" }}
                    >
                      My sessions
                    </MuiLink>{' '}
                    to view your updates.
                  </Typography>

                  {/* Create New Button */}
                  <Button
                    variant="outlined"
                    onClick={() => window.location.reload()}
                    sx={{
                      mt: 3,
                      color: "#1E90FF",
                      borderColor: "#1E90FF",
                      letterSpacing: 2,
                      '&:hover': {
                        backgroundColor: "#1E90FF",
                        color: "#ffffff",
                      },
                    }}
                  >
                    Create New
                  </Button>
                </Box>
              )}

            </Box>

            {loading && (
              <Box
                sx={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  zIndex: 2000,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backdropFilter: 'blur(3px)',
                }}
              >
                <Box sx={{ textAlign: 'center' }}>
                  <CircularProgress
                    size={60}
                    thickness={6}
                    sx={{
                      color: 'transparent',
                      '& .MuiCircularProgress-circle': {
                        stroke: 'url(#better-gradient)',
                      },
                    }}
                  />

                  <svg width="0" height="0">
                    <defs>
                      <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#f30b96ff" />     {/* pinkish-purple */}
                        <stop offset="50%" stopColor="#221ce0ff" />     {/* deep lavender */}
                        <stop offset="100%" stopColor="#0eacebff" />    {/* bright sky blue */}
                      </linearGradient>
                    </defs>
                  </svg>

                  <Typography
                    variant="h6"
                    sx={{
                      mt: 2,
                      color: '#fff',
                      textShadow: '0 1px 3px rgba(0,0,0,0.7)',
                    }}
                  >
                    Posting Your Session... ({loadingSeconds} sec)
                  </Typography>
                </Box>
              </Box>
            )}



            <Snackbar
              open={openSnackbar}
              autoHideDuration={20000}
              onClose={() => setOpenSnackbar(false)}
            >
              <Alert severity="error" sx={{ width: '100%' }} onClose={() => setOpenSnackbar(false)}>
                {error}
              </Alert>
            </Snackbar>
          </Container>
        </Box>
      </Box>
      <Footer2 />
    </div>
  );
};

export default CreateRequest1;
